import { Button, Input, InputGroup } from "reactstrap";
import { Href, Submit, SubscribeText, SubscribeTitle } from "../../Constants/Constants";

const Subscribe = () => {
  return (
    <section className="section-py-space pt-0 submit-section">
      <div className="custom-container">
        <div className="submit-img">
          <div>
            <h2>{SubscribeTitle}</h2>
            <p>{SubscribeText}</p>
            <InputGroup>
              <Input type="text" name="text" placeholder="Email" />
              <Button tag={"a"} href={Href}>{Submit}</Button>
            </InputGroup>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Subscribe;
